module.exports = __webpack_public_path__ + "media/images/chat-bg-black-35461802305b3e2f9f0f0b667efb01d0.jpg";